var React = require('react');

function RemixShieldFlashLine (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0z","key":0}),React.createElement("path",{"d":"M3.783 2.826L12 1l8.217 1.826a1 1 0 0 1 .783.976v9.987a6 6 0 0 1-2.672 4.992L12 23l-6.328-4.219A6 6 0 0 1 3 13.79V3.802a1 1 0 0 1 .783-.976zM5 4.604v9.185a4 4 0 0 0 1.781 3.328L12 20.597l5.219-3.48A4 4 0 0 0 19 13.79V4.604L12 3.05 5 4.604zM13 10h3l-5 7v-5H8l5-7v5z","key":1})]);
}

RemixShieldFlashLine.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = RemixShieldFlashLine;

RemixShieldFlashLine.default = RemixShieldFlashLine;
